import { render, staticRenderFns } from "./SupportCategoryAddForm.vue?vue&type=template&id=121f7acf&scoped=true&"
import script from "./SupportCategoryAddForm.vue?vue&type=script&lang=js&"
export * from "./SupportCategoryAddForm.vue?vue&type=script&lang=js&"
import style0 from "./SupportCategoryAddForm.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./SupportCategoryAddForm.vue?vue&type=style&index=1&id=121f7acf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "121f7acf",
  null
  
)

export default component.exports